<mat-card class="ui-wrapper">
    <div class="row">
        <div class="col-md-6">
            <mat-card-title>Logs</mat-card-title>
        </div>
        <div class="col-md-6 text-end">
            <mat-form-field appearance="outline">
                <mat-label>Filter by date</mat-label>
                <mat-date-range-input [formGroup]="dateRangeForm" [rangePicker]="dateRangePicker"
                    [comparisonStart]="dateRangeForm.value.start_date" [comparisonEnd]="dateRangeForm.value.end_date">
                    <input matStartDate placeholder="Start date" formControlName="start_date">
                    <input matEndDate placeholder="End date" formControlName="end_date">
                </mat-date-range-input>
                <mat-hint>YYYY/MM/DD – YYYY/MM/DD</mat-hint>
                <mat-datepicker-toggle matSuffix [for]="dateRangePicker"></mat-datepicker-toggle>
                <mat-date-range-picker #dateRangePicker></mat-date-range-picker>
            </mat-form-field>
        </div>
    </div>

    <mat-paginator [length]="totalNumberOfLogs" [pageIndex]="page-1" [pageSize]="limit" [pageSizeOptions]="[10, 15, 20]"
        showFirstLastButtons (page)="onPageChange($event)" aria-label="Select page of logs">
    </mat-paginator>

    <div class="py-2">
        <mat-divider></mat-divider>
    </div>

    <table mat-table [dataSource]="logsDataSource" class="log-list">

        <ng-container matColumnDef="entity_id">
            <th mat-header-cell *matHeaderCellDef> Entity id </th>
            <td mat-cell *matCellDef="let log"> {{log.entity_id}} </td>
        </ng-container>

        <ng-container matColumnDef="entity">
            <th mat-header-cell *matHeaderCellDef> Entity </th>
            <td mat-cell *matCellDef="let log"> {{ log.entity }} </td>
        </ng-container>

        <ng-container matColumnDef="log_type">
            <th mat-header-cell *matHeaderCellDef> Log type </th>
            <td mat-cell *matCellDef="let log"> {{ log.log_type }} </td>
        </ng-container>


        <ng-container matColumnDef="date_and_time">
            <th mat-header-cell *matHeaderCellDef> Date and time </th>
            <td mat-cell *matCellDef="let log"> {{ utilService.toDateString(log.created_at) }} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row (click)="viewLog(row)" *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
</mat-card>